import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AuthService } from '../guard/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private readonly HTTPUTILS_MARKER = 'x-httputils-service';
    constructor(private router: Router, private authService: AuthService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Skip adding auth header if request is from HttpUtilsService
        if (req.headers.has(this.HTTPUTILS_MARKER)) {
            // Remove the marker header and proceed without adding auth
            const cleanedReq = req.clone({
                headers: req.headers.delete(this.HTTPUTILS_MARKER)
            });
            return next.handle(cleanedReq).pipe(
                catchError(err => this.handleError(err))
            );
        }

        // Add auth token for all other requests
        const token = localStorage.getItem('oktaAccessToken');
        let requestToHandle = req;
        if (token) {
            requestToHandle = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${token}`)
            });
        }

        return next.handle(requestToHandle).pipe(
            catchError(err => this.handleError(err))
        );
    }

    private handleError(err: any): Observable<never> {
        if (err instanceof HttpErrorResponse && err.status === 401) {
            this.authService.logout();
        }
        return throwError(() => err);
    }
}
